module.exports = __webpack_public_path__ + "media/site_templates/www.localtilers.com.au/images/feature_2-bbbbee712858ce4c79c55e959106d9e1.jpeg";